import { render, staticRenderFns } from "./AsignarInstitucion.vue?vue&type=template&id=fc5bc034"
import script from "./AsignarInstitucion.vue?vue&type=script&lang=js"
export * from "./AsignarInstitucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports